import React from 'react';
import { stats } from '../data/content';
export function StatsBar() {
  return <section className="w-full bg-brand-800 px-4 py-10 sm:px-6 sm:py-14" data-id="element-270" data-mp="1tarjq9bipqkw">
      <div className="mx-auto max-w-5xl" data-id="element-271" data-mp="1t8dp21kr2gdv">
        <h2 className="text-center font-display text-[22px] font-bold leading-snug text-white sm:text-3xl" data-id="element-272" data-mp="1oam0nhjbdcef">
          Built for dentists who want more natural-looking resin veneers
        </h2>
        <dl className="mt-8 grid grid-cols-2 gap-3 sm:gap-4 lg:grid-cols-4" data-id="element-273" data-mp="1edr597ic7s4d">
          {stats.map(stat => <div key={stat.label} className="flex h-full flex-col rounded-2xl bg-brand-900/60 px-3 py-5 text-center ring-1 ring-white/10" data-id="element-274" data-mp="19lg3dz41dw96">
              <dt className="font-display text-[26px] font-bold leading-none text-white sm:text-4xl" data-id="element-275" data-mp="10mciqqp818sk">
                {stat.value}
              </dt>
              <dd className="mt-auto pt-3 text-[11px] font-bold uppercase leading-tight tracking-[0.08em] text-brand-200" data-id="element-276" data-mp="vly9547z1qsf">
                {stat.label}
              </dd>
            </div>)}
        </dl>
      </div>
    </section>;
}